import React from 'react';
import { LOGIN_OR_REGISTRATION_MODAL_NAME } from 'src/app/shared/components/modals/loginOrRegistration/const';
import { LoginOrRegistrationModalProps } from 'src/app/shared/components/modals/loginOrRegistration/types';
import { useModal } from 'src/shared/modalProvider';

export const useLoginOrRegistration = () => {
  const { openModal } = useModal();

  return React.useCallback(
    (props: LoginOrRegistrationModalProps = {}) => {
      openModal(LOGIN_OR_REGISTRATION_MODAL_NAME, props);
    },
    [openModal],
  );
};
